import { useDispatch, useSelector } from 'react-redux';
//@ts-expect-error no types
import AutoSaveContainer from 'ContentEditorUI/containers/AutoSaveContainer';
//@ts-expect-error no types
import { getHasContentModel } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getIsAppReadyForSaving } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { selectCanSave, selectSaveData, autoSave, autoSaveDebounced, validate } from '../data/editor/save';
import { jsx as _jsx } from "react/jsx-runtime";
const keysForHardSave = [];
const keysToReload = []; // keys that require preview reload

const AutoSave = () => {
  const dispatch = useDispatch();
  const hasContentModel = useSelector(getHasContentModel);
  const saveData = useSelector(selectSaveData);
  const isAppReadyForSaving = useSelector(getIsAppReadyForSaving);
  const canSave = useSelector(selectCanSave);
  if (!isAppReadyForSaving || !hasContentModel) {
    return null;
  }
  return /*#__PURE__*/_jsx(AutoSaveContainer, {
    autoSaveDebounced: () => dispatch(autoSaveDebounced()),
    autoSave: () => dispatch(autoSave()),
    saveData: saveData,
    canSave: canSave,
    keysForHardSave: keysForHardSave,
    keysToReload: keysToReload,
    validate: () => dispatch(validate())
  });
};
export default AutoSave;